<template>
  <colored-popup
    :back-action="back"
    class="danger exclude-card"
  >
    <template v-slot:top-content>
      <div class="header">
        מה יקרה עכשיו?
      </div>
    </template>
    <template v-slot:bottom-content>
      <span class="title">מעכשיו, המערכת לא תציג יותר בתזרים את פירוט העסקאות של הכרטיס הזה.</span>
      <ToolTip icon-path="/images/info-icon-blue.svg" class="tooltip">
        <span class="bold">לאיזה מקרה זה מומלץ?</span>

        <ul class="bullet-list">
          <li>כרטיס אשראי שמקושר לחשבון עסקי</li>
          <li>כרטיס שאני לא רוצה לראות את הפירוט שלו</li>
        </ul>

      </ToolTip>
      <RiseupButton :action="excludeCard" :size="'slim'" :title="'הבנתי, זאת הכוונה שלי'" :variant="'secondary'"/>
    </template>
    <template v-slot:footer>
      <div class="footer-btn" @click="cancel">ביטול</div>
    </template>
  </colored-popup>
</template>

<script>
import BaseUI from '@riseupil/base-ui';
import ToolTip from '@/base-components/onboarding/BaseToolTip.vue';
import { answerSonQuestion } from '@/api/MergeInvestigatorApi';
import { mapState, mapActions } from 'vuex';
import Segment from '@/Segment';

export default {
  name: 'ExcludeCardModal',
  components: {
    ToolTip,
    ColoredPopup: BaseUI.ColoredPopup,
    RiseupButton: BaseUI.RiseupButton,
  },
  props: {
    investigation: {
      type: Object,
      required: true,
    },
    insightId: {
      type: String,
    },
  },
  computed: {
    ...mapState('mergeInvestigationQuestions', ['cardInputTypes']),
  },
  methods: {
    ...mapActions('insights', ['clearInsight']),
    ...mapActions('modalRootStore', ['closeAllModals', 'closeModal']),
    async excludeCard() {
      Segment.trackUserInteraction('SonsMergeInvestigationExcludeCardAcceptClicked', { investigation: this.investigation });
      await answerSonQuestion({
        chunkId: this.investigation.chunkId,
        input: this.cardInputTypes.excluded,
        accountNumberPiiId: this.investigation.accountNumberPiiId,
      });
      if (this.insightId) {
        await this.clearInsight({ insightId: this.insightId });
      }
      this.closeAllModals();
    },
    back() {
      Segment.trackUserInteraction('SonsMergeInvestigationExcludeCardBackClicked', { investigation: this.investigation });
      this.closeModal();
    },
    cancel() {
      Segment.trackUserInteraction('SonsMergeInvestigationExcludeCardCancelClicked', { investigation: this.investigation });
      this.closeAllModals();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@riseupil/base-ui/src/scss/riseup-colors';

.header {
  font-size: 22px;
  font-weight: bold;
  line-height: 28px;
  color: $riseup_white;
}

.exclude-card {
  text-align: right;
}

.tooltip {
  font-size: 14px;
  line-height: 18px;
  margin-top: 30px;
  margin-bottom: 35px;
}

.bullet-list {
  padding-inline-start: 20px;
}

.footer-btn {
  display: flex;
  justify-content: center;
  font-size: 18px;
  color: $riseup_black;
  cursor: pointer;
}

.title {
  line-height: 24px;
}
</style>
